import { useApiQuery } from '~/hooks';
import { getPreferencesApi } from '../repository';

export const PREFERENCES_QUERY_KEYS = {
  PREFERENCES: 'user-preferences',
};

/**
 * Query hook to fetch current user's preferences
 * @returns React Query result with user preferences data
 */
export const useGetPreferencesQuery = () => {
  return useApiQuery({
    queryKey: [PREFERENCES_QUERY_KEYS.PREFERENCES],
    queryFn: () => getPreferencesApi(),
  });
};
